import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FileText, PlayCircle, Share2, BarChart3, RefreshCw, Wand2 } from 'lucide-react';
interface SlideWhatSnakkerDoesProps {
  onContinue: () => void;
}
export function SlideWhatSnakkerDoes({
  onContinue
}: SlideWhatSnakkerDoesProps) {
  const [stage, setStage] = useState(0);
  const steps = [{
    id: 'ingest',
    icon: <FileText className="w-6 h-6 text-teal-400" data-id="element-962" />,
    title: 'Ingest',
    desc: 'Takes existing approved content'
  }, {
    id: 'transform',
    icon: <Wand2 className="w-6 h-6 text-purple-400" data-id="element-963" />,
    title: 'Transform',
    desc: 'Turns them into short interactive Snaks'
  }, {
    id: 'publish',
    icon: <Share2 className="w-6 h-6 text-sky-400" data-id="element-964" />,
    title: 'Publish',
    desc: 'Distributes across all channels'
  }, {
    id: 'learn',
    icon: <BarChart3 className="w-6 h-6 text-rose-400" data-id="element-965" />,
    title: 'Learn',
    desc: 'Captures behavioral data'
  }, {
    id: 'improve',
    icon: <RefreshCw className="w-6 h-6 text-amber-400" data-id="element-966" />,
    title: 'Improve',
    desc: 'Optimizes the next campaign'
  }];
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 400);
    const t2 = setTimeout(() => setStage(2), 1000);
    const timers = steps.map((_, idx) => setTimeout(() => setStage(3 + idx), 1500 + idx * 350));
    const finalTimer = setTimeout(() => setStage(3 + steps.length), 1500 + steps.length * 350 + 300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      timers.forEach(clearTimeout);
      clearTimeout(finalTimer);
    };
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-14 max-w-6xl mx-auto" data-id="element-967">
      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-968">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-969">
          What a campaign looks like
        </h2>
        <p className="text-xl text-white/60" data-id="element-970">
          The operating layer between strategy and execution.
        </p>
      </motion.div>

      {/* Flow diagram */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: stage >= 2 ? 1 : 0,
      y: stage >= 2 ? 0 : 20
    }} transition={{
      duration: 0.6
    }} className="flex-1 flex items-center justify-center mt-10" data-id="element-971">
        <div className="w-full rounded-2xl bg-white border border-white/10 shadow-2xl overflow-hidden" data-id="element-972">
          <img src="https://cdn.magicpatterns.com/uploads/aDhBbAFowWKRHKXg1acHd3/Screenshot_2026-05-28_at_11.46.20.png" alt="Flow Example Campaign — Hook to Snak to Insights" className="w-full h-auto block" data-id="element-973" />
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 6 ? 1 : 0
    }} className="mt-16 flex justify-center" data-id="element-974"></motion.div>
    </div>;
}